<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="listRtpEngine"
      single-expand
      :search="search"
      :loading="loading"
      item-key="callid"
      class="alignTableOnBackground ml-5 mr-5 elevation-1"
    >
      <template v-slot:item.Instance="{ item }">
        {{ clearName(item.Instance) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    search: String,
    listRtpEngine: [],
  },
  data: () => ({
    headers: [
      { text: "ID", value: "ID", sortable: "false" },
      { text: "Nombre", value: "Instance", sortable: "false" },
      { text: "Status", value: "InstanceStatus", sortable: "true" },
      { text: "IP", value: "InternalIP", sortable: "true" },
    ],
  }),
  methods: {
    clearName(item) {
      return item.split("/")[10];
    },
  },
};
</script>
